/* unplugin-vue-components disabled */import script from "./SearchTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchTitle.vue?vue&type=script&setup=true&lang=ts"

import "./SearchTitle.vue?vue&type=style&index=0&id=0bf40cb8&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf40cb8"]])

export default __exports__